import mobx, { observable, action, computed } from 'mobx';
import api from '../../api';
// import accountStore from '../accountStore';
// import appStore from '../appStore';

export default class Result {

	store = null;
	@observable data = null;
	@observable isLoading = 0;

	constructor(store) {
		this.store = store;
	}

	@action init(id) {
		this.store.isLoading = 0;
		this.getData(id);
	}

	@action getData(id){
		api.toto.getResult(id).then(
			action( data => { 
				if (data.code == "OK") {
					this.data = data.result;
				}
			}))
      .catch(action(err => {
        this.store.setResult('SERVER_TEMPORARILY_DOWN');
      }))
      .finally(action(() => { this.store.isLoading = 1 }));
	}
}


// WEBPACK FOOTER //
// ./src/stores/totoStore/result.js